export const selectCustomerList = [
  { title: '需求ID', dataIndex: 'id' },
  { title: '需求类型', dataIndex: 'typeName' },
  {
    title: '姓名',
    dataIndex: 'name',
    render(text, record) {
      return record?.bizCustomVo?.name || ''
    },
  },
  {
    title: '电话',
    dataIndex: 'phone',
    render(text, record) {
      return record?.bizCustomVo?.phone || ''
    },
  },
  {
    title: '公司',
    dataIndex: 'companyName',
  },
  {
    title: '楼盘名称',
    dataIndex: 'buildingName',
    render(text, record) {
      return record?.bizBuildVo?.name || ''
    },
  },
  {
    title: '房号',
    dataIndex: 'houseNumber',
    render(text, record) {
      return record?.houseInfoVo?.houseNumber ?? ''
    },
  },
  {
    title: '需求状态',
    dataIndex: 'stateName',
  },
]
